import { DependencyTypes } from '../enums/DependencyTypes';
import { Area, AreaAttendance, Attendance, Continent, Country, CountryAttendance, Unfiltered, RankedArea, RankedAreaDiscipline, RankedAttendance, RankedAttendanceDiscipline, RankedContinent, RankedContinentAttendance, RankedCountry, RankedCountryAttendance, RankedCountryDiscipline, RankedDiscipline, RankedUnfiltered } from '../organisations/policies';
export class SearchIndexabilityManager {
    policies;
    constructor(portalType, seoInfoBase, filterState, sortingState, applicationState) {
        const dependencies = {
            dependencyType: DependencyTypes.SEARCH,
            seoInfoBase,
            filterState,
            sortingState,
            applicationState,
            portalType
        };
        this.policies = [
            new Area(dependencies),
            new AreaAttendance(dependencies),
            new Attendance(dependencies),
            new Continent(dependencies),
            new Country(dependencies),
            new CountryAttendance(dependencies),
            new Unfiltered(dependencies),
            new RankedArea(dependencies),
            new RankedAreaDiscipline(dependencies),
            new RankedAttendance(dependencies),
            new RankedAttendanceDiscipline(dependencies),
            new RankedContinent(dependencies),
            new RankedContinentAttendance(dependencies),
            new RankedCountry(dependencies),
            new RankedCountryAttendance(dependencies),
            new RankedCountryDiscipline(dependencies),
            new RankedDiscipline(dependencies),
            new RankedUnfiltered(dependencies)
        ];
    }
    async shouldIndex() {
        const results = await Promise.all(this.policies.map((policy) => policy.shouldIndex()));
        return results.some((result) => result);
    }
}
